// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-channels {
  display: flex;
  flex-direction: row;
  gap: 2px;
  margin-bottom: 4px;
}
.chat-channels .chat-channel {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  padding: 2px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-weight: 600;
  font-size: 0.9em;
  color: #fafafa;
  opacity: 0.65;
  transition: opacity 0.15s ease, border-color 0.15s ease;
  text-shadow: 0 0 3px #000, 0 0 3px #000, 1px 1px 2px #000, -1px -1px 2px #000;
}
.chat-channels .chat-channel:hover {
  opacity: 0.95;
}
.chat-channels .chat-channel:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 1px;
}
.chat-channels .chat-channel.active {
  opacity: 1;
  border-bottom-color: var(--gold-main);
}
.chat-channels .chat-channel.channel-hrp.active {
  color: #7dd3fc;
}
.chat-channels .chat-channel.channel-system.active {
  color: #9a9a9a;
}
.chat-channels .chat-channel .chat-channel-unread {
  display: inline-block;
  min-width: 14px;
  margin-left: 5px;
  padding: 0 4px;
  border-radius: 10px;
  background: #c0392b;
  color: #fff;
  font-family: sans-serif;
  font-size: 0.75em;
  line-height: 14px;
  text-align: center;
  text-shadow: none;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/constructorComponents/chat/channels/styles.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAAF;AAEE;EACE,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,yDAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uDAAA;EACA,6EAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAGI;EACE,oCAAA;EACA,mBAAA;AADN;AAII;EACE,UAAA;EACA,qCAAA;AAFN;AAMI;EACE,cAAA;AAJN;AAOI;EACE,cAAA;AALN;AAQI;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AANN","sourcesContent":["// Same HUD label recipe as the rest of the chat: heavy outline so the tabs stay readable over any game background.\r\n.chat-channels {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 2px;\r\n  margin-bottom: 4px;\r\n\r\n  .chat-channel {\r\n    background: transparent;\r\n    border: none;\r\n    border-bottom: 2px solid transparent;\r\n    cursor: pointer;\r\n    padding: 2px 10px;\r\n    font-family: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\r\n    font-weight: 600;\r\n    font-size: 0.9em;\r\n    color: #fafafa;\r\n    opacity: 0.65;\r\n    transition: opacity 0.15s ease, border-color 0.15s ease;\r\n    text-shadow: 0 0 3px #000, 0 0 3px #000, 1px 1px 2px #000, -1px -1px 2px #000;\r\n\r\n    &:hover {\r\n      opacity: 0.95;\r\n    }\r\n\r\n    &:focus-visible {\r\n      outline: 2px solid var(--gold-light);\r\n      outline-offset: 1px;\r\n    }\r\n\r\n    &.active {\r\n      opacity: 1;\r\n      border-bottom-color: var(--gold-main);\r\n    }\r\n\r\n    // The active colour mirrors the message colour of that channel\r\n    &.channel-hrp.active {\r\n      color: #7dd3fc;\r\n    }\r\n\r\n    &.channel-system.active {\r\n      color: #9a9a9a;\r\n    }\r\n\r\n    .chat-channel-unread {\r\n      display: inline-block;\r\n      min-width: 14px;\r\n      margin-left: 5px;\r\n      padding: 0 4px;\r\n      border-radius: 10px;\r\n      background: #c0392b;\r\n      color: #fff;\r\n      font-family: sans-serif;\r\n      font-size: 0.75em;\r\n      line-height: 14px;\r\n      text-align: center;\r\n      text-shadow: none;\r\n      vertical-align: middle;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
